import { adaptMap, adaptMapBoundsAndCenter, adaptStaticMapSrc } from 'stores/adapters/bex-api/migration-adapters/search/map';
import { adaptMapAndProperties } from 'stores/adapters/bex-api/migration-adapters/search/map-and-properties';
import { adaptPropertiesWave1, adaptPropertiesWave2 } from 'stores/adapters/bex-api/migration-adapters/search/properties';
import { adaptResultsSummary } from 'stores/adapters/bex-api/migration-adapters/search/results-summary-messages';
import { adaptSortAndFilters } from 'stores/adapters/bex-api/migration-adapters/search/sort-and-filter';
import { BffResponseRetrofitAdapter, MigrationExperimentMapping, SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';

// Key/value pairs of experiment names and their associated adapters.
export const searchMigrationExperimentMapping: MigrationExperimentMapping = {
  shopping_pwa_mm_bex_api_lodging_map: adaptMap,
  shopping_pwa_mm_bex_api_lodging_properties_baseline: adaptMapAndProperties,
  shopping_pwa_mm_bex_api_lodging_properties_wave_1: adaptPropertiesWave1,
  shopping_pwa_mm_bex_api_lodging_properties_wave_2: adaptPropertiesWave2,
  shopping_pwa_mm_bex_api_lodging_map_staticmap: adaptStaticMapSrc,
  shopping_pwa_mm_bex_api_lodging_map_bigmap: adaptMapBoundsAndCenter
};

// Adapters here to stay. Taken out of `searchMigrationExperimentMapping` and put in this list,
// after parity has been established in testing.
export const searchMigrationAdapters: SearchMigrationAdapter[] = [adaptResultsSummary, adaptSortAndFilters];

export const bffResponseRetrofitAdapters: BffResponseRetrofitAdapter[] = [];
